export const bundleUltimate = {
  title: 'FightCamp The Works Bundle',
  id: 'fightcamp_bundle_ultimate',
  price: 50000,
  category: 'accessory',
  img_url: 'https://a.storyblok.com/f/152150/1440x1280/aac6fe1c44/ultimatebundle.jpg',
  images: [],
  fbid: '',
};
